import { useResize } from '@hooks/useResize';
import { unit } from '@lib/style/unit';
import { ApplicationContext } from '@packages/layout';
import { PAGE_HEADER_THEME } from '@packages/layout/lib/PageHeader/theme';
import { FixedMountPoint, FixedMountPointProps } from '@packages/portals/lib/FixedMountPoint';
import { handleResizePoint } from '@packages/portals/lib/utils';
import { createMemo } from '@packages/react';
import React, { useContext } from 'react';

export const HeaderMountPoint = createMemo<Omit<FixedMountPointProps, 'name'>, { POINT: string }>(
    (props) => {
        const [, actions] = useContext(ApplicationContext);

        useResize(
            handleResizePoint(HeaderMountPoint.POINT, {
                readProp: 'clientHeight',
                writeProp: (value, writeElement) => (writeElement.style.paddingTop = `${unit(value)}`),
                after: ({ event }) => {
                    if (!event.data || !event.data.skipDrawer) {
                        actions.dynamicDrawer(event);
                    }
                },
            }),
        );

        return (
            <FixedMountPoint
                name={HeaderMountPoint.POINT}
                top={0}
                l={0}
                r={0}
                z={PAGE_HEADER_THEME.get('zIndex')}
                {...props}
            />
        );
    },
    {
        displayName: 'HeaderMountPoint',
        POINT: 'layout-header',
    },
);
